import React from "react";
import { Navigate, useNavigate } from "react-router-dom";

const ProtectedRouter = ({ children }) => {
  const navigate = useNavigate();
  let hasToken = JSON.parse(sessionStorage.getItem("auth"));
  if (!hasToken) {
    setTimeout(() => {
     return navigate("/");
      // <Navigate to="/" replace />;
    }, 2000);
  }
  return children;
};

export default ProtectedRouter;
